<template>
  <tr>
    <td class="text-center">
      {{ item.fecha | date }}
    </td>
    <td>
      {{ item.codigo }}
    </td>
    <td>
      {{ item.file }}
    </td>
    <td>
      {{ item.servicio }}
    </td>
    <td>
      {{ item.hotel }}
    </td>
    <td class="text-center">
      {{ item.servicioTipo }}
    </td>
    <td class="text-center">
      {{ item.nroAdultos }}
    </td>
    <td class="text-center">
      {{ item.nroNinos }}
    </td>
    <td class="text-center">
      <template v-if="liquidado">{{ item.moneda }}</template>
      <InputSelect
        v-else
        v-model="item.tempMoneda"
        :inputClass="'form-control-table text-center'"
        :options="monedas"
        :reduce="(opt) => opt.sigla"
        label="sigla"
        rules="required"
        :errorMode="'tooltip'"
        name="Moneda"
        :vid="`moneda_${item.id}`"
      ></InputSelect>
    </td>
    <td class="text-center">
      <template v-if="liquidado">{{ item.tarifa | number(2) }}</template>
      <InputText
        v-else
        v-model="item.tarifa"
        :vid="`tarifa_${item.id}`"
        :errorMode="'tooltip'"
        name="Monto"
        rules="required|number"
        :inputClass="'form-control form-control-table text-center'"
      ></InputText>
    </td>
    <td>
      <template v-if="liquidado">{{ item.observaciones }}</template>
      <InputTextArea
        v-else
        v-model="item.observaciones"
        :vid="`observaciones_${item.id}`"
        :errorMode="'tooltip'"
        :name="'Observaciones'"
        inputClass="form-control form-control-table"
      ></InputTextArea>
    </td>
  </tr>
</template>

<script>
import InputSelect from '../../shared/components/InputSelect.vue'
import InputText from "../../shared/components/InputText.vue";
import InputTextArea from "../../shared/components/InputTextArea.vue";

export default {
  components: { InputTextArea, InputText, InputSelect },
  props: {
    item: Object,
    liquidado: Boolean,
    monedas: Array
  },
  methods: {},
};
</script>

<style></style>
